import { createApi } from "@reduxjs/toolkit/query/react";
import { userProfileApiUrl } from "../../../env";
import { makeResilientBaseQuery } from "../../redux/api/baseQuery";

export const emptyUserProfileApi = createApi({
	reducerPath: "userProfileApi",
	baseQuery: makeResilientBaseQuery({
		baseUrl: userProfileApiUrl,
	}),
	tagTypes: ["UserProfile"],
	endpoints: () => ({}),
});
